// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","secondary":"#33C370","goal-wrapper":"_2bVJhisYX0AhkDLOPnJ7l1","container":"_3CHU4IqLk1OzgvDl9GnOoM","input-wrapper":"_29NGpAycbI8pUxFr0rxeA_","input-container":"_2tJydac1veiB1H86k36lVC","number":"tfL3XTl3Eq-_LJKYL2poM","label":"_2ekgVjS4Wpd07hW5xj7bJB","button":"_2hnLfhRhQQlidEWO0YSAOV","add-item-icon":"_3FJwzwiPxiHfujxqaI2g_I","remove-item-icon":"Qc54kr7GJH_2u1_F_e1-Q","award":"_2zfE3wdepLNZCLI4pSAXxZ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/GoalInput.mod.css
// module id = 1709
// module chunks = 0